import { themeColors } from "../../themeColors";
/**
 * @file  src\mobile\pages\ClientFavorites.js
 * @brief  This file is responsible for agent client favourites
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MenuBottomBar from "../components/v2/menuBottomMobile";
import { getFavClientList } from "../../services/wantAdService";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { classesBasedOnScroll, getUserType } from "../../helpers/common";
import moment from "moment";
import Sortoffcanvas from "../components/common/Sortoffcanvas";
import TopHeader from "../components/common/TopHeader";
import userProfile from "../../appState/userProfile";
import {
  FREE_PLAN,
  SCROLL_DIRECTION_DOWN,
  USER_TYPE_AGENT,
} from "../../constants/common";
import HandleScroll from "../commonComponents/HandleScroll";
import { usePremium } from "@/hooks";
import BackLinkButton from "../components/BackLinkButton";

const ClientFavorites = (props) => {
  const scrollStates = HandleScroll();
  const isReachedBottom = _.get(scrollStates, "isReachedBottom", null);
  const scrollDirection = _.get(scrollStates, "direction", null);
  const INITIAL_PAGE_INDEX = 1;
  const navigate = useNavigate();
  const userDetailsFromStore = userProfile();
  const userType = getUserType();
  useEffect(() => {
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  // useEffect(() => {
  //   if (userType !== USER_TYPE_AGENT) {
  //     navigate(pageURLs.proDashboard);
  //   } else if (
  //     userDetailsFromStore !== null &&
  //     userDetailsFromStore?.length > 0
  //   ) {
  //     if (
  //       userDetailsFromStore[0]?.period &&
  //       userDetailsFromStore[0]?.period === FREE_PLAN
  //     ) {
  //       navigate(pageURLs.proDashboard);
  //     }
  //   }
  // }, [userDetailsFromStore]);

  const [showSort, setShowSort] = useState(false);
  const [currPage, setCurrPage] = useState(INITIAL_PAGE_INDEX); // storing current page number
  const [searchKey, setSearchKey] = useState(null); // storing current page number
  const [favClients, setFavClients] = useState(null); // storing current page number

  const options = [
    { value: "recently added", label: "Recently Favourited" },
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];
  const sortClose = () => setShowSort(false);
  const sortShow = () => setShowSort(true);
  const [sortParam, setSortParam] = useState(options[0]);

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    const reqPayload = {
      sortBy: sortParam?.value,
      sortDir: sortParam?.label === "Oldest" ? "asc" : "desc",
      page: currPage,
      limit: 10,
      search: searchKey,
    };
    getFavoriteClientList(reqPayload);
  }, [currPage, searchKey, sortParam]);

  const handleSearchOnChange = (e) => {
    setCurrPage(INITIAL_PAGE_INDEX);
    setSearchKey(e.target.value);
  };

  function Clients(props) {
    const clients = props.clients;
    let clientFullName = null;
    if (clients.FirstName && !clients.LastName) {
      clientFullName = clients.FirstName;
    } else if (!clients.FirstName && clients.LastName) {
      clientFullName = clients.LastName;
    } else if (clients.FirstName && clients.LastName) {
      clientFullName = clients.FirstName + " " + clients.LastName;
    } else {
      clientFullName = "Unassigned";
    }

    return (
      <a
        href={void 0}
        onClick={() =>
          navigate(pageURLs.mobileWantAdFavorites, {
            state: {
              clientName: clientFullName,
              clientId: clients.ClientId,
              favCount: clients.FavCount,
            },
          })
        }
        className="list-Whitewrap mb-3 d-flex align-items-center"
        role="button"
      >
        <span className="profile-bg-meroon profileIcnDiv me-2 align-items-center">
          {clientFullName?.replace(/-/g, "").match(/\b(\w)/g)}
        </span>
        <div>
          <span className="labelTxt">
            {" "}
            {clients.ClientId == null ? "Unassigned" : clientFullName}
            {clients.FavCount > 1 && "(" + clients.FavCount + ")"}
          </span>
          <p>
            {" "}
            Last added{" "}
            {clients.CreatedOn
              ? moment(new Date(clients.CreatedOn)).format("MM/DD/YY")
              : ""}
          </p>
        </div>
      </a>
    );
  }

  useEffect(() => {
    if (isReachedBottom) {
      setCurrPage((prevState) => prevState + 1);
    }
  }, [isReachedBottom]);
  /**
   * To get want ad favourited clients list
   * @param {*} reqPayload
   */
  const getFavoriteClientList = async (reqPayload) => {
    await getFavClientList(reqPayload)
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const list = _.get(response, "result", null);
          if (reqPayload.page === 1) {
            setFavClients(list);
          } else {
            setFavClients([...favClients, ...list]);
          }
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const handleSortSelection = (selectedItem) => {
    setSortParam(selectedItem);
    sortClose();
  };

  const { mainWrapperClass, contentWrapperClass } =
    classesBasedOnScroll(scrollDirection);

  return (
    <div className={mainWrapperClass}>
      <div className={contentWrapperClass}>
        <TopHeader
          variant="threeComp"
          outerClassname="bg-white"
          topClassName="w-100 flex-column top-three-comp-headerborder"
          bottomClassName="w-100"
        >
          <BackLinkButton
            shouldToggleColor={shouldToggleColor}
            onClick={() => navigate(pageURLs.proDashboard)}
          />
          <div className={shouldToggleColor ? "heading-premium" : "heading"}>
            Client Favorites
          </div>
          <div className="p-0 toplinks-mobile">
            <div
              className={`topbar-links sort-icon-header ${shouldToggleColor ? "sort-icon-header-premium" : ""}`}
              onClick={() => sortShow()}
            ></div>
          </div>

          <Sortoffcanvas
            show={showSort}
            onHide={sortClose}
            handleSortParam={handleSortSelection}
            options={options}
            sortParam={sortParam}
          />
        </TopHeader>

        <div className="home-layout-content">
          <div className="pe-3 ps-3 pt-4 ">
            <div className="row">
              <div className="col-12 mb-3">
                <div className=" position-relative">
                  <div className="search_field_input position-relative mb-0 input-group d-flex">
                    <input
                      aria-label="Example"
                      aria-describedby="basic-addon3"
                      placeholder="Client Name"
                      className="form-control pr-0"
                      value={searchKey}
                      onChange={(e) => handleSearchOnChange(e)}
                    ></input>

                    <button
                      type="button"
                      id="button-addon3"
                      className="search-icon "
                    ></button>
                  </div>
                </div>
              </div>
            </div>

            {favClients?.length > 0 && (
              <div className="title-selection-wrap">
                {favClients?.map((clients, i) => {
                  return <Clients key={i} clients={clients} ival={i} />;
                })}
              </div>
            )}

            {favClients && favClients?.length === 0 && (
              <div className="no-data no-data-heightfix d-flex align-items-center  justify-content-center flex-column text-center">
                <h4>You don't favorited any want-listings.</h4>
                <p className="m-0">
                  Use the explore tab to browse for want-listings. When you find
                  one you want to favorite, use the Heart icon in the top right
                  corner.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {scrollDirection !== SCROLL_DIRECTION_DOWN && (
        <MenuBottomBar
          wrapperClassName={
            "inner-layout-footer-new inner-layout-footer-topfix"
          }
          scrollDirection={scrollDirection}
        />
      )}
    </div>
  );
};

export default ClientFavorites;
